import { MuiButton } from '@/components/button/MuiButton';
import { Box, Chip, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export function SearchFilterButton({
  text,
  selectedFiltersLabel,
  onClick,
  filterCount,
}: {
  text: string;
  selectedFiltersLabel: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  filterCount: number;
}) {
  return (
    <Box
      sx={{
        flexGrow: 1,

        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <MuiButton
        endIcon={<KeyboardArrowDownIcon />}
        onClick={onClick}
        variant="outlined"
        color={filterCount > 0 ? 'primary' : 'inherit'}
        sx={{
          width: '100%',
          minWidth: 160,
          paddingTop: 1,
          paddingBottom: 1,
          height: 44,
        }}
      >
        <Typography
          variant="JP/Body/m/Regular/Tight"
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            textAlign: 'left',
            flex: 1,
          }}
        >
          {text}
        </Typography>
        {filterCount > 0 && (
          <Chip color="primary" size="small" label={filterCount} />
        )}
      </MuiButton>
      <Typography
        sx={{
          fontSize: '14px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: '2',
          WebkitBoxOrient: 'vertical',

          '@media (max-width: 740px)': {
            display: 'none',
          },
        }}
      >
        {selectedFiltersLabel}
      </Typography>
    </Box>
  );
}
